<template>
  <div
    class="modal black"
    id="filterModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl"
      role="document"
      v-if="selectedBid"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"></h5>
          <div class="action ">
            <!-- <a href="#" class="mx-3"><i class="fa fa-expand"></i></a> -->
            <a @click="$emit('close')" aria-label="Close"
              ><i class="fa fa-times "></i
            ></a>
          </div>
        </div>

        <div class="modal-body">
          <div class="">
            <div class="bond-info mb-3">
              <span class="info-chip cusip">
                <label>CUSIP</label>{{ selectedBid.cusip }}
              </span>

                <span class="info-chip description">
                <label>Description</label>
                <span class="description-text">{{ selectedBid.description || selectedBid.issuer }}</span>
                </span>

              <span class="info-chip coupon">
                <label>Coupon</label>
                {{ selectedBid.coupon | percent(3) }}
              </span>

              <span class="info-chip maturity">
                <label>Maturity</label>
                {{ selectedBid.maturityDate }}
              </span>

              <span class="info-chip callable">
                <label>Callable</label>
                {{
                  selectedBid.callDate && selectedBid.callPrice
                    ? `${selectedBid.callDate} @ ${selectedBid.callPrice}`
                    : 'No'
                }}
              </span>
              

              <span class="info-chip rating">
                <label>Rating</label>
                {{ selectedBid.ratingSP || '—' }}
              </span>
              <span
                class="info-chip bank"
              
              >
                <label>insurance </label>
                {{ selectedBid.bondInsurer ? selectedBid.bondInsurer : 'N/A' }}
              </span>
            </div>

            <!-- {{
              [
                selectedBid.issuer || selectedBid.description || '',
                selectedBid.callDate && selectedBid.callPrice
                  ? `Next call Date: ${selectedBid.callDate} @${selectedBid.callPrice}`
                  : '',
                selectedBid.coupon
                  ? convertToPercentage(selectedBid.coupon)
                  : '',
                selectedBid.maturityDate || '',
                selectedBid.isBankQualified ? 'Bank: Qualified' : '',
                selectedBid.ratingSP || ''
              ]
                .filter(Boolean)
                .join(', ')
            }} -->
            <!-- MASSACHUSETTS EDL FING AUTH ED LN REV, Next call Date: 07/01/2031@100, 4.949%, 07/01/2038, AA -->
          </div>

          <div class="row mb-4 align-items-end" >
            <div class="col d-flex flex-column">
              <label class="form-label">Quantity Available</label>
              <input
                type="number"
                class="form-control"
                placeholder="0"
                :disabled="true"
                v-model="offerQuantityAvailable"
              />
            </div>
            <div class="col d-flex flex-column">
              <label class="form-label">{{bidType == 'BID' ? 'Enter Quantity to Bid' : 'Quantity you wish to Buy'}}</label>
              <input
                type="number"
                class="form-control"
                placeholder="0"
                v-model="offerQuantity"
                @change="calcuteProceeds"
              />
            </div>

            <div class="col d-flex flex-column">
              <label class="form-label"> {{ bidType == 'BID' ? 'YOUR BID PRICE ($)' : 'PRICE ($)' }}   </label>
              <input
                :disabled="bidType === 'BUY'"
                type="text"
                class="form-control"
                placeholder="$0.00"
                v-model="offerPrice"
                @change="calcuteProceeds"

              />
            </div>

            <div class="col d-flex flex-column">
              <label class="form-label">Settlement</label>
              <input
                type="text"
                class="form-control"
                :value="selectedBid.settlementDate"
                disabled
              />
              <!-- <datepicker
                :disabled="true"
                v-model="selectedBid.settlementDate"
                placeholder="mm/dd/yyyy"
                typeable
                name="settlementDate"
                format="MM/dd/yyyy"
                :calendar-button="true"
                calendar-button-icon="fas fa-calendar-alt datepicker_icon"
              ></datepicker> -->
            </div>

            <div class="col-auto d-flex">
              <button
                class="btn btn-outline-primary"
                @click="calcuteProceeds()"
              >
                Calc Proceeds
              </button>
            </div>
          </div>

          

          <div class="row mt-4 mb-5 values" v-if="calculatedProceeds">
            <div class="col">
              <span>PRINCIPAL</span
              ><span>{{ calculatedProceeds.principal | currency }}</span>
            </div>
            <div class="col">
              <span>ACCRUED</span
              ><span>{{ calculatedProceeds.accrued | currency }}</span>
            </div>
            <div class="col">
              <span>NETMONEY</span
              ><span>{{ calculatedProceeds.proceeds | currency }}</span>
            </div>
            <div class="col">
              <span>YIELD TO WORST</span
              ><span>{{ calculatedProceeds.ytw }}%</span>
            </div>
            <div class="col">
              <span>YIELD TO MATURITY</span
              ><span>{{ calculatedProceeds.ytm }}%</span>
            </div>
            <div class="col">
              <span>YIELD TO CALL</span
              ><span>{{ calculatedProceeds.ytc }}%</span>
            </div>
          </div>

          <!-- THIS DIV WAS MISSING -->
          <div class="mt-5 mb-2">
            <button
              :disabled="!selectedBid.askQty || !selectedBid.askPx || !this.isClient"
              class="btn btn-primary"
              v-if="bidType === 'BID'"
              @click="sendBidOrBuy"
            >
              BID
            </button>
            <button
              :disabled="!selectedBid.askQty || !selectedBid.askPx || !this.isClient"
              class="btn btn-success"
              v-if="bidType === 'BUY'"
              @click="sendBidOrBuy"
            >
              BUY
            </button>
          </div>
        </div>
        <!-- closes modal-body -->
      </div>
      <!-- closes modal-content -->
    </div>
    <!-- closes modal-dialog -->
  </div>
  <!-- closes modal -->
</template>

<script>
// import Datepicker from 'vuejs-datepicker'
import config from '@/config'
import authService from '@/authService'

export default {
  name: 'BidOrBuyModal',
  components: {
    // Datepicker
  },
  props: {
    selectedBid: {
      type: Object,
      required: false
    },
    bidType: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isBid: true,
      calculatedProceeds: null,
      offerPrice: this.selectedBid ? this.selectedBid.askPx : null,
      offerQuantity: null,
      isClient : false,
      offerQuantityAvailable : this.selectedBid ? this.selectedBid.askQty : null,
    }
  },
  methods: {
    getUserSetting () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/tradebook/setting-list?cognitoSub=' +
            authService.getUser().cognitoSub,
          auth
        )
        .then(result => {
          this.userSettings = result.data
          this.userSettings.forEach(element => {
            if (element.setting == 'CLIENT_OFFERING_FEED_SETTLEMENT_DATE') {
              if(element.value && !this.selectedBid.settlementDate) {
                this.selectedBid.settlementDate = element.value;
                
              }
            }
          })
          this.loading = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    calcuteProceeds () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let url = config.baseUrlAutoBidder + '/offering-feed/proceeds'
      let body = {
        cusip: this.selectedBid.cusip,
        price: this.offerPrice,
        quantity: this.offerQuantity,
        settlementDate: this.selectedBid.settlementDate
          ? this.moment(this.selectedBid.settlementDate).format('YYYY-MM-DD')
          : null,
        userId: authService.getUser().id
      }
      this.$http.post(url, body, auth).then(res => {
        this.calculatedProceeds = res.data
      })
    },
    sendBidOrBuy () {
      if(this.selectedBid.minQty && this.offerQuantity < this.selectedBid.minQty) {
        this.$alert(`Minimum quantity for this offering is ${this.selectedBid.minQty}. Please adjust your quantity.`, '', 'error')
        return;
      }
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let url = config.baseUrlAutoBidder + '/offering-feed/client-bid'
      let body = {
        userId: authService.getUser().id,
        cusip: this.selectedBid.cusip,
        quantity: this.offerQuantity,
        price: this.offerPrice,
        offerPrice: this.selectedBid.askPx,
        status: 'PENDING',
        bidType: this.bidType,
        offeringFeedHitId: this.selectedBid.id,
        cusipId: this.selectedBid.cusipId,
        offerQuantity: this.selectedBid.askQty,
        ecn: this.selectedBid.ecn,
        cusipDescription : this.selectedBid.description || this.selectedBid.issuer,
        minQuantity : this.selectedBid.minQty,
      }
      this.$http
        .post(url, body, auth)
        .then(() => {
          this.isBidModalOpen = false
          // this.$toast.success(`${this.bidType} placed successfully!`);
          this.$alert(
            `Your ${
              this.bidType == 'BUY' ? 'Order' : 'Bid'
            } has been received and currently being processed.`,
            '',
            'success'
          )
          this.$emit('close')
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(
            `Failed to place ${this.bidType}. Please try again.`
          )
        })
    }
  },
  mounted () {

    this.getUserSetting()
     this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Client')   ? this.isClient  = true : this.isClient  = false;

        }
      });
  }
}
</script>
<style scoped>
.bond-info {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  /* background: #1b1e2b; */
  padding: 12px 16px;
  border-radius: 8px;
  justify-content: center;
}

.info-chip {
  display: flex;
  gap: 6px;
  align-items: center;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 13px;
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
  min-width: 150px;
}

.info-chip label {
  font-weight: 600;
  color: #9ca3af;
  font-size: 12px;
}

/* Accent colors */




.bond-card {
  background: linear-gradient(180deg, #0f172a, #020617);
  border: 1px solid #1e293b;
  border-radius: 14px;
  padding: 16px 18px 18px;
  color: #e5e7eb;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
}

.bond-card-header {
  font-size: 15px;
  font-weight: 600;
  color: #38bdf8;
  margin-bottom: 14px;
  letter-spacing: 0.3px;
}

.bond-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.info-chip {
  background: rgba(30, 41, 59, 0.65);
  border: 1px solid #334155;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
}

.info-chip label {
  font-size: 11px;
  color: #94a3b8;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.info-chip span {
  font-size: 14px;
  font-weight: 600;
  color: #f8fafc;
}

/* Special accents */
.info-chip.cusip span {
  color: #22d3ee;
  font-family: monospace;
}

.description-text {
  display: block;
  max-width: 300px;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
}


</style>
